import { useState } from "react"
import MakeTable from "./MakeTableCom"
import { OVERVIEW_CHARTS_CLIENTS, OVERVIEW_TITLE } from "../../Data/Variables";
import DynamicCatalogueChart from "./CatalogChart";

export const MakeTableWrapper = ({index, isPins, tableLen, setLoaderGap, clientName, spotiSongList, isPivot, 
                                    dataDir, tableData, tableName, outputKind, jwt, isNotTitleCount}) =>
{
    const [tab, setTab] = useState(0);
    return  <>
                {Object.values(tableData)[0][0] ===  OVERVIEW_TITLE[1] && OVERVIEW_CHARTS_CLIENTS.includes(clientName) ?
                    <div className="tabs is-boxed pb-0 mb-0">
                        <ul>
                            <li className={tab === 0 ? "is-active" : ""} onClick={() => setTab(0)}>
                                <a><span className="icon is-small"><i class="fa-solid fa-table" /></span><span>Table View</span></a>
                            </li>
                            <li className={tab === 1 ? "is-active" : ""} onClick={() => setTab(1)}>
                                <a><span className="icon is-small"><i class="fa-solid fa-chart-line" /></span><span>Chart View</span></a>
                            </li>
                        </ul>
                    </div> : <></>}
                {tab === 0 ?
                    <MakeTable index={index} isPins={isPins} 
                                tableLen={tableLen} setLoaderGap={setLoaderGap} clientName={clientName} 
                                spotiSongList={spotiSongList} isPivot={isPivot} dataDir={dataDir} 
                                tableData={tableData} tableName={tableName} outputKind={outputKind} jwt={jwt} isNotTitleCount={isNotTitleCount} />
                : 
                <>
                    <DynamicCatalogueChart dataObject={tableData}/>
                </>}
            </>
}